/* globals urls, RSVP */

//var $ = jQuery.noConflict();

window.BasePopup = function(popupName){
	var self = this;
	// Common
    this.RSVP = RSVP;
    this.name = popupName;
    this.submitButtonSelector = '#kois-popup-contain #'+popupName+'-button';
    this.errorMessageSelector = '#kois-popup-contain #popup-messages-target';
    
    this.init();
}

BasePopup.prototype.init = function(){
    this.initPopupEvents();
};

BasePopup.prototype.initPopupEvents = function(){
    this.initPopupSubmitEvent();
};

BasePopup.prototype.initPopupSubmitEvent = function(){
    console.log('initPopupSubmitEvent function needs to be overridden for this popup type');
};

BasePopup.prototype.disableSubmitButton = function(){
    $(this.submitButtonSelector).prop( 'disabled', true ).addClass( 'loading' );
};

BasePopup.prototype.enableSubmitButton = function(){
    $(this.submitButtonSelector).prop( 'disabled', false ).removeClass( 'loading' );
};

BasePopup.prototype.setErrorMessage = function(message){
    var self = this;
    $.ajax({
        method: "POST",
        url: urls.ajax,
        data: { action: 'symp_validation_error', title: 'Error', text: message }
    })
    .done(function( res ) {
        if(res && res.success){
            $(self.errorMessageSelector).html(res.data.message);
        }
        else{
            $(self.errorMessageSelector).html('<p class="kois-error-text">'+message+'</p>');
        }
    });
};

BasePopup.prototype.clearErrorMessage = function(){
    $(this.errorMessageSelector).html('');
};